import {getReportParams, report} from '../../../../middleware/report';

export function dwhSelectPaymentOptionDisplay({debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Private Debt Payment';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Debt Choose Payment method';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Debt Choose Payment method Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = debtAmount;
  reportParams.param2 = selectedAmount;
  reportParams.param5 = source;
  reportParams.customerName = customerName;
  (reportParams.banId = ban), (reportParams.idNumber = idNumber), report(reportParams);
}
export function dwhSelectPaymentOption({messageText, debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Private Debt Payment';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Debt Choose Payment method';
  reportParams.status = 'Ongoing';
  reportParams.messageText = messageText;
  reportParams.subscriber = subscriber;
  reportParams.param1 = debtAmount;
  reportParams.param2 = selectedAmount;
  reportParams.param5 = source;
  reportParams.customerName = customerName;
  (reportParams.banId = ban), (reportParams.idNumber = idNumber), report(reportParams);
}

export function dwhBitPaymentNotCompleted({debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Private Debt Payment';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'BIT Payment Details Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'BIT Payment Not Completed Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = debtAmount;
  reportParams.param2 = selectedAmount;
  reportParams.param5 = source;
  reportParams.customerName = customerName;
  (reportParams.banId = ban), (reportParams.idNumber = idNumber), report(reportParams);
}

export function dwhBitPaymentNotPossible({debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Private Debt Payment';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'BIT Payment Details Page';
  reportParams.status = 'Error';
  reportParams.messageText = 'BIT Payment Not Possible Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = debtAmount;
  reportParams.param2 = selectedAmount;
  reportParams.param5 = source;
  reportParams.customerName = customerName;
  (reportParams.banId = ban), (reportParams.idNumber = idNumber), report(reportParams);
}
export function dwhBitPaymentSuccess({debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Private Debt Payment';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'BIT Payment Details Page';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Success';
  reportParams.subscriber = subscriber;
  reportParams.param1 = debtAmount;
  reportParams.param2 = selectedAmount;
  reportParams.param5 = source;
  reportParams.customerName = customerName;
  (reportParams.banId = ban), (reportParams.idNumber = idNumber), report(reportParams);
}
